import React, { Component } from 'react';
import { Modal, ModalBody } from 'reactstrap';
import limit_speed_upload_icon from 'images/limit_speed_upload.png';

export default class LimitSpeedUploadModal extends Component {
  constructor(props) {
    super(props);
    this.modalRef = React.createRef();
  }

  handleModalBackClick = (e) => {
    if (!this.props.isOpen) return;

    if (typeof this.closeModal === 'function') {
      this.closeModal();
    } else if (this.props.onClickClose) {
      this.props.onClickClose();
    } else if (this.props.toggle) {
      this.props.toggle();
    }
  };

  componentDidMount() {
    document.addEventListener('tm-modal-back-click', this.handleModalBackClick);

    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('tm-modal-back-click', this.handleModalBackClick);

    document.removeEventListener('mousedown', this.handleClickOutside);
  }
  handleClickOutside = (event) => {
    if (this.modalRef.current && !this.modalRef.current.contains(event.target)) {
      this.props.onClickClose();
    }
  };

  renderModal() {
    const { isOpen, onClickClose } = this.props;

    return (
      <Modal isOpen={isOpen} toggle={onClickClose} innerRef={node => (this.modalRef = node)} id='LimitSpeedUploadModal' className="animation-uploader-modal modal-dialog-centered modal-style limit-speed-upload-modal">
        <ModalBody className='mt-2' style={{paddingTop: '10px'}}>
          <div className='d-flex justify-content-center'>
            <img src={limit_speed_upload_icon} alt="limit speed upload" width="50" height="36" />
            <div className='text-black font-weight-bold ml-2'>
              <span><a href={Routes.owner_total_info_path()} target="_blank" className="text-black text-underline">Standardプラン以上に変更</a>することで</span> <br />
              <span> アップロードスピードや容量制限が大幅に改善されます。</span>
            </div>
          </div>
        </ModalBody>
      </Modal>
    );
  }

  render() {
    return this.renderModal();
  }
};
